import Css from "./style.module.scss";

import * as Icons from "@phosphor-icons/react";
import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import DateRangePickerExtended from "nlib/common/DateRangePickerExtended";
import DebounceInput from "nlib/ui/DebounceInput";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import Row from "nlib/ui/Row";
import classNames from "classnames";

const Filters = ({ className, disabled, filters, onChange }) => {
  const { uiTexts } = useSelector(getTextsData);

  const {
    text = "",
    fromDate = "",
    toDate = ""
  } = filters;

  const [textInputValue, setTextInputValue] = useState(text);

  const fromToDate = useMemo(() => [fromDate, toDate], [fromDate, toDate]);

  const handleTextInputComplete = useCallback((value) => {
    onChange({ text: value || null });
  }, [onChange]);

  const handleDateChange = useCallback((value) => {
    const [from, to] = value;

    onChange({ fromDate: from, toDate: to });
  }, [onChange]);

  useEffect(() => {
    setTextInputValue(text || "");
  }, [text]);

  return (
    <div className={classNames(Css.filters, className)}>
      <Row>
        <DebounceInput
          cleanable
          disabled={disabled}
          active={!!text}
          className={Css.search}
          placeholder={uiTexts.searchDocuments}
          value={textInputValue}
          onChange={setTextInputValue}
          onInputComplete={handleTextInputComplete}
          iconBefore={Icons.MagnifyingGlass} />

        <DateRangePickerExtended
          range
          active={!!fromDate && !!toDate}
          value={fromToDate}
          className={Css.dateRange}
          placeholder={uiTexts.selectDate}
          onChange={handleDateChange} />
      </Row>
    </div>
  );
};

export default React.memo(Filters);
